export const localStorageKey = 'airsoftklubzadar-authUser';
